export type { SourceRange } from './selection-to-source-range';

/**
 * Kind marking an annotation a coder created, as opposed to one a producer
 * asserted. Not a spec kind: the spec's `kind` set is closed and describes
 * machine-produced annotations, and human annotations live outside the layer
 * payload entirely (ADR-0005). This value exists only so the renderer can
 * style a coder's own span apart from a section or an entity.
 */
export const ANNOTATION_KIND_CODER_SPAN = 'coderSpan';
